module.exports = __webpack_public_path__ + "assets/nacos.147e9bf5.svg";